import React from 'react';
import { useAppSelector } from '../../hooks/redux';

interface ProfileHeaderProps {
  className?: string;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ className = '' }) => {
  const { user } = useAppSelector((state) => state.auth);

  const getInitials = () => {
    if (user?.profile?.displayName) {
      return user.profile.displayName
        .split(' ')
        .map((n: string) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
    }
    if (user?.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return 'U';
  };

  return (
    <div className={`mb-6 ${className}`}>
      <div className="flex items-center gap-4">
        {user?.profile?.avatar ? (
          <img src={user.profile.avatar} alt="Avatar" className="w-20 h-20 rounded-full" />
        ) : (
          <div className="w-20 h-20 bg-[var(--color-brand-primary)] rounded-full flex items-center justify-center text-white font-bold text-2xl flex-shrink-0">
            {getInitials()}
          </div>
        )}
        <div className="flex-1">
          <h1 className="text-3xl font-bold text-[var(--color-default-font)] mb-1">
            {user?.profile?.nickname ? user.profile.nickname : user?.profile?.displayName || 'Profile'}
          </h1>
          <p className="text-[var(--color-subtext-color)]">
            {user?.email}
          </p>
          {user?.profile?.bio && (
            <p className="text-sm text-[var(--color-subtext-color)] mt-2">
              {user.profile.bio}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;

